
export const org = ({ org }) => org;
export const lastUpdatedDataOrg = ({ lastUpdatedDataOrg }) => lastUpdatedDataOrg;
export const images = ({ images }) => images;
export const getPhonsContact = ({ phons }) => phons;
export const getEmailcontact = ({ emails }) => emails;
export const isSolicitation = ({ solicitation }) => solicitation;
 